import script from "./QuestionStats.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuestionStats.vue?vue&type=script&lang=ts&setup=true"

import "./QuestionStats.vue?vue&type=style&index=0&id=3b5f5441&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5f5441"]])

export default __exports__